import service from '@/utils/request'
// 查询询价单明细
export function srmXjOrderDetailList(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderDetail/srmXjOrderDetailList',
        data: param
    })
}
// 查询询价单明细 不分页
export function srmXjOrderDetailListAll() {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderDetail/list',
    })
}
// 新增询价单明细
export function addSrmXjOrderDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderDetail/add',
        data: param
    })
}

// 新增轮次信息
export function addSrmXjOrderLc(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderLc/add',
        data: param
    })
}
export function editSrmXjOrderLc(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderLc/edit',
        data: param
    })
}

// 获取轮次信息
export function getSrmXjOrderLcList(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderLc/srmXjOrderLcList',
        data: param
    })
}


// 修改询价单明细
export function editSrmXjOrderDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderDetail/edit',
        data: param
    })
}

// 批量删除询价单明细
export function batchDelSrmXjOrderDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderDetail/batchDel',
        data: param
    })
}



// 删除询价单明细
export function delSrmXjOrderDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderDetail/del',
        data: param
    })
}
// 导出询价单明细
export function exportSrmXjOrderDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderDetail/export',
        data: param
    })
}
// 获取询价详情
export function getSrmXjOrderLcDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderLc/getSrmXjOrderLcDetail',
        data: param
    })
}

// 获取订单的附件列表

export function querySrmXjOrderFileListByOrderId(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderFile/querySrmXjOrderFileListByOrderId',
        data: param
    })
}

// 新增订单的附件
export function srmXjOrderFileAdd(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderFile/add',
        data: param
    })
}

// 删除订单附件
export function srmXjOrderFileDel(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderFile/del',
        data: param
    })
}

// 编辑订单的附件
export function srmXjOrderFileEdit(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderFile/edit',
        data: param
    })
}

// 删除询价轮次
export function srmXjdelBid(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderLc/del',
        data: param
    })
}

// 完结询价轮次
export function finishSrmXjOrderLc(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderLc/finishSrmXjOrderLc',
        data: param
    })
}

// 发布询价轮次
export function publishSrmXjOrderLc(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderLc/publishSrmXjOrderLc',
        data: param
    })
}

// 发布询价轮次
export function basicProductById(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicProduct/basicProductById',
        data: param
    })
}

// 新增评委
export function addJudgeSaveList(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderJudgment/addSaveList',
        data: param
    })
}

// 新增评委
export function delJudge(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderJudgment/del',
        data: param
    })
}

// 获取评委列表
export function getJudgeList(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderJudgment/srmXjOrderJudgmentList',
        data: param
    })
}

// 获取评委列表
export function updateBjList(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderDetailUser/updateList',
        data: param
    })
}

// 提交报价

export function submitOrderBj(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderUser/submitOrder',
        data: param
    })
}

// 整单结束询价
export function finishOrderXj(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrder/finishOrderXj',
        data: param
    })
}

// 获取定标明细
export function getFinalOrder(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrder/getFinalOrder',
        data: param
    })
}

// 开标
export function kaibiaoSrmXjOrderLc(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderLc/kaibiaoSrmXjOrderLc',
        data: param
    })
}

// 上传定标数据
export function dingbiaoOrder(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderDetailUser/dingbiaoOrder',
        data: param
    })
}

// 发起审批、审批
// auditStatus：2驳回，3通过    auditRemark:审批备注
export function auditOrder(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrder/auditOrder',
        data: param
    })
}

// 获取审记录日志
export function getOrderAuditListByOrderId(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderAudit/getOrderAuditListByOrderId',
        data: param
    })
}

// 发送中标通知
export function zhongbiaoOrderNotice(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrder/zhongbiaoOrderNotice',
        data: param
    })
}

// 生成采购订单
export function generateFinalOrder(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrder/generateFinalOrder',
        data: param
    })
}

// 生成合同
export function generateContract(param) {
    return service.request({
        method: 'POST',
        url: '/contract/add',
        data: param
    })
}


// 采购员 获取订单列表
export function srmFinalOrderList(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmFinalOrder/srmFinalOrderList',
        data: param
    })
}

// 采购员 获取订单列表
export function srmFinalOrderDetailList(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmFinalOrderDetail/srmFinalOrderDetailList',
        data: param
    })
}

// 采购员 获取订单列表
export function getLastOrderState(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderAudit/getLastOrderState',
        data: param
    })
}

// 导出中标结果
export function exportWord(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrder/exportWord',
        data: param
    })
}

// 获取报价须知列表
export function srmXjOrderRemarkList(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderRemark/srmXjOrderRemarkList',
        data: param
    })
}
// 新增报价须知
export function addSrmXjOrderRemark(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderRemark/add',
        data: param
    })
}
// 编辑报价须知
export function editSrmXjOrderRemark(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderRemark/edit',
        data: param
    })
}
// 删除报价须知
export function delSrmXjOrderRemark(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderRemark/del',
        data: param
    })
}

// 导出报价表
export function exportSrmXjOrderLcDetail(param) {
    return service.request({
        method: 'POST',
        url: '/app/srmXjOrderLc/exportSrmXjOrderLcDetail',
        data: param,
        responseType: 'arraybuffer',
        downbinary:true
    })
}













